// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__DTkdw","row":"styles_row__3QjPr"};